export default {
  ADJUDICATION_PASSED: 'ADJUDICATION_PASSED',
};
